export enum QUERY_KEY {
  GET_ME = 'GET_ME',
  FIND_ALL_RESTAURANT = 'FIND_ALL_RESTAURANT',
  FIND_ONE_RESTAURANT = 'FIND_ONE_RESTAURANT',
  FIND_ALL_FUNDRAISER = 'FIND_ALL_FUNDRAISER',
  FIND_ONE_FUNDRAISER = 'FIND_ONE_FUNDRAISER',
}
